import React from 'react';

import {
	type MentionAgentsSpotlightFeatureId,
	mentionAgentsSpotlightAcknowledgementStore,
} from './MentionAgentsSpotlightAcknowledgementStore';

type MentionAgentsSpotlightVisibilityTrackerProps = {
	children: React.ReactNode;
	featureId: MentionAgentsSpotlightFeatureId;
};

/**
 * Marks a spotlight as abandoned for the page session after its rendered content unmounts.
 *
 * This component must be rendered inside `PostOfficeMessageInstance` so a message denied by the
 * choreographer is never treated as visible. The microtask generation guard ignores React Strict
 * Mode's development-only effect cleanup and re-run while still recording a real unmount, such as
 * closing the Rovo sidebar.
 */
export const MentionAgentsSpotlightVisibilityTracker = ({
	children,
	featureId,
}: MentionAgentsSpotlightVisibilityTrackerProps): React.JSX.Element => {
	const effectStateRef = React.useRef({ generation: 0 });

	React.useEffect(() => {
		const effectState = effectStateRef.current;
		const effectGeneration = ++effectState.generation;

		return () => {
			queueMicrotask(() => {
				if (effectState.generation === effectGeneration) {
					mentionAgentsSpotlightAcknowledgementStore.acknowledge(featureId);
				}
			});
		};
	}, [featureId]);

	return <>{children}</>;
};
